module.exports = __webpack_public_path__ + "media/images/world-map-aa88b757f2d5e590cc964c301287ce49.svg";